window.Products.DeviceCase.IphoneXR = function() {
};
window.Products.DeviceCase.IphoneXR.inherits(window.Products.DeviceCase.DeviceCase);

window.Products.DeviceCase.IphoneXR.id = 82;
window.Products.DeviceCase.IphoneXR.slug = 'iphonexr';
window.Products.DeviceCase.IphoneXR.has_3d = true;
window.Products.DeviceCase.IphoneXR.dpi = 300;

window.Products.DeviceCase.IphoneXR.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.66;
	modelViewer.object.rotation.x = 90 * (Math.PI/180);
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.IphoneXR.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.1;
	controls.maxDistance = 4.1;
};

window.Products.DeviceCase.IphoneXR.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[0].material[0].map = modelViewer.texture;
};